import React from 'react';
import { useSelector } from 'react-redux';
import { getWorkspaceDisplayLabel } from 'Shared/selectors/workspace';

import './TeammateOrGroupLink.scss';

type Props = {
  workspaceId: string;
  workspacePath: string;
  itemUuid: string;
};

function TeammateOrGroupLink({ workspaceId, itemUuid, workspacePath }: Props) {
  const displayLabel = useSelector(getWorkspaceDisplayLabel(workspaceId));

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`${workspacePath}/item/${itemUuid}`}
      className="teammate-or-group-link d-flex text-decoration-none"
    >
      <div className="ml-2 text-break">{displayLabel}</div>
    </a>
  );
}

export default TeammateOrGroupLink;
